import Http from '@/api/http.js'

export default {
  //index = lista todos
  //show = mostra um
  index(filter) {
    return Http.get('/employees', {
      params: {
        ...filter
      }
    })
  },
  indexWithParams(params) {
    return Http.get('/employees', {
      params: {
        ...params
      }
    })
  },
  index_overdue_client_transactions(){
    return Http.get('/employees/index_overdue_client_transactions')
  },
  indexByManager(manager_id) {
    return Http.get(`/employees?manager_id=${manager_id}`)
  },

  create(newEmployee) {
    return Http.post('/employees', {
      employee: {
        company_id: 1,
        status_id: newEmployee.status_id,
        comissionFloor: newEmployee.jobDetails.comissionFloor,
        comissionStep: newEmployee.jobDetails.comissionStep,
        comissionType: newEmployee.jobDetails.comissionTypeEnum,
        profitFloor: newEmployee.jobDetails.profitFloor,
        profitStep: newEmployee.jobDetails.profitStep,
        salary: newEmployee.jobDetails.salary_to_create,
        team: newEmployee.team || 'none',
        'user_attributes': newEmployee.user_attributes,
        'contacts_attributes': newEmployee.contacts_attributes,
        'address_attributes': newEmployee.address_attributes,
        'accounts_attributes': newEmployee.accounts_attributes,
        'driver_attributes': newEmployee.driver_attributes,
        'vrt_account_attributes': newEmployee.vrt_account_attributes,
        'goals_attributes': [newEmployee.goals_attributes],
        comissions_attributes: newEmployee.comissions_attributes,
        brand_ids: newEmployee.brand_ids,
        modality_ids: newEmployee.modality_ids,
        manager_id: newEmployee.manager_id,
      },
      role: {
        id: newEmployee.jobDetails.job
      }

    });
  },

  updateDocument(updateEmployee){
    const {id, document_attributes} = updateEmployee
    return Http.put(`/employees/${id}`, {
      employee: {
        id,
        document_attributes,
      }
    })
  },

  updateManagerId(updateEmployee){
    const {id, manager_id, subordinate_ids} = updateEmployee
    return Http.put(`/employees/${id}`, {
      employee: {
        id,
        manager_id,
        subordinate_ids,
      }
    })
  },

  update(employee){
    return Http.put(`/employees/${employee.id}`, { employee })
  },
  changeUser(updateEmployee) {
    return Http.put(`/employees/${updateEmployee.id}`, {
      employee: {
        id: updateEmployee.id,
        'user_attributes':      updateEmployee.user_attributes,
      }
    });
  },
  updateInfo(updateEmployee, id) {
    return Http.put(`/employees/${id}`, {
      employee: {
        id: id,
        team: updateEmployee.team,
        comissions_attributes: updateEmployee.comissions_attributes,
        'user_attributes':      updateEmployee.user_attributes,
      }
    });
  },
  updateFinancial(updateEmployee, id) {
    return Http.put(`/employees/${id}`, {
      employee: {
        id: id,
        comissionFloor: updateEmployee.comissionFloor,
        comissionStep:  updateEmployee.comissionStep,
        comissionType:  updateEmployee.comissionTypeEnum,
        profitFloor:    updateEmployee.profitFloor,
        profitStep:     updateEmployee.profitStep,
        salary:         updateEmployee.salary_to_update,

        'vrt_account_attributes': updateEmployee.vrt_account_attributes,
        'goals_attributes': [updateEmployee.goals_attributes],
        
        comissions_attributes: updateEmployee.comissions_attributes,

      },
      role: {
        name: updateEmployee.newRole
      }
    });
  },
  updateContact(updateEmployee, id) {
    return Http.put(`/employees/${id}`, {
      employee: {
        id: id,
        'contacts_attributes':  updateEmployee.contacts_attributes,
      }
    });
  },
  updateAccount(updateEmployee, id) {
    return Http.put(`/employees/${id}`, {
      employee: {
        id: id,
        'accounts_attributes':  updateEmployee.update_accounts_attributes,
      }
    });
  },
  updateAddress(updateEmployee, id) {
    return Http.put(`/employees/${id}`, {
      employee: {
        id: id,
        'address_attributes':   updateEmployee.address_attributes,
      }
    });
  },
  updateCompanies(updateEmployee, id) {
    return Http.put(`/employees/${id}`, {
      employee: {
        id: id,
        modality_ids: updateEmployee.modality_ids,
        company_id: updateEmployee.company_id
      }
    });
  },
show(id, filter) {
    return Http.get(`/employees/${id}`,{
      // headers: {
      //   filter: JSON.stringify(filter)
      // }
    });
  },
}
